module.exports = __webpack_public_path__ + "static/media/image_3_5.26daf289.svg";